import { Smartphone, QrCode } from "lucide-react";

/* QR code generated via a public service. URL points to the same site for now. */
const QR_TARGET = typeof window !== "undefined" ? window.location.origin : "https://ridemateapp.in";
const QR_SRC = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
  QR_TARGET
)}&size=420x420&margin=10&color=24303F&bgcolor=ffffff&qzone=2`;

export default function QRSection() {
  return (
    <section
      id="download"
      data-testid="qr-section"
      className="relative py-28 md:py-36 border-t border-[#e5e7eb] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 reveal">
          <span className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
            Get the app
          </span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl font-black tracking-[-0.03em] leading-tight text-[#24303F]">
            Scan. Install.
            <br />
            <span className="text-gray-400">Start pooling.</span>
          </h2>
          <p className="mt-6 font-body text-gray-600 text-base md:text-lg max-w-xl leading-relaxed">
            RideMate launches soon on Android and iOS. Scan the QR with your phone
            to pre-register — we'll text you a download link the moment we go live.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <StoreBadge label="Google Play" sub="Coming soon" />
            <StoreBadge label="App Store" sub="Coming soon" />
          </div>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="relative mx-auto max-w-sm">
            <div className="rounded-3xl border border-[#e5e7eb] bg-white p-7 ring-green">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 font-display font-bold text-sm text-[#24303F]">
                  <QrCode className="w-4 h-4 text-[#5FA836]" />
                  ridemateapp.in
                </div>
                <div className="font-display text-[10px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
                  Pre-register
                </div>
              </div>
              <div className="mt-5 rounded-2xl bg-[#F9FAFB] p-3 border border-[#e5e7eb]" data-testid="qr-image-wrap">
                <img
                  src={QR_SRC}
                  alt="Scan to pre-register on RideMate"
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>
              <div className="mt-5 flex items-center gap-3 text-gray-600">
                <Smartphone className="w-4 h-4" />
                <span className="font-body text-sm">
                  Point your camera at the QR code
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const StoreBadge = ({ label, sub }) => (
  <div
    data-testid={`store-badge-${label.toLowerCase().replace(/\s+/g, "-")}`}
    className="rounded-2xl border border-[#e5e7eb] bg-white px-5 py-3"
  >
    <div className="font-body text-[10px] uppercase tracking-[0.2em] text-gray-500">
      {sub}
    </div>
    <div className="font-display font-bold text-base text-[#24303F]">{label}</div>
  </div>
);
